import styled from 'styled-components';

export const TotalCardContentStyle = styled.div`
  width: 300px;
  border: ${({ theme }) => {
    return theme.border;
  }};
  border-radius: ${({ theme }) => {
    return theme.borderRadius.small;
  }};
  padding: 3px;
  h4 {
    padding: 5px;
    margin: 0;
    font-size: ${({ theme }) => {
      return theme.fonts.size.small;
    }};
    font-weight: ${({ theme }) => {
      return theme.fonts.weight.thin;
    }};
    background-color: ${({ theme }) => {
      return theme.colors.white;
    }};
  }
`;

export const Content = styled.div`
  display: flex;
  justify-content: space-between;
  p {
    margin: 2px 0;
    font-size: ${({ theme }) => {
      return theme.fonts.size.small;
    }};
    font-weight: ${({ theme }) => {
      return theme.fonts.weight.thin;
    }};
  }
`;
